import { render, staticRenderFns } from "./Front.vue?vue&type=template&id=5f35bf4e"
import script from "./Front.vue?vue&type=script&lang=js"
export * from "./Front.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports